export default __webpack_public_path__ + "static/media/forkedlightning.a96e1d04.png";